export default __webpack_public_path__ + "static/media/contact.6e88cda7.jpeg";